import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILED,
  EDIT_NOTIFICATIONS,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILED,
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { getSupabase } from '../config/configureSupabase';
import store from '../store/store';

export const fetchUserNotifications = () => async (dispatch) => {
  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  const supabase = getSupabase();
  const uid = store.getState().auth?.profile?.uid || store.getState().auth?.profile?.id;

  if (supabase && uid) {
    try {
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('user_id', uid)
        .order('created_at', { ascending: false });

      if (!error && data) {
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: data
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_NOTIFICATIONS_SUCCESS,
    payload: []
  });
};

export const fetchNotifications = () => async (dispatch) => {
  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const userInfo = store.getState().auth?.profile;
      let query = supabase.from('notifications').select('*').order('created_at', { ascending: false });
      if (userInfo?.tenant_id) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }
      const { data, error } = await query;
      if (!error && data) {
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: data
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_NOTIFICATIONS_SUCCESS,
    payload: []
  });
};

export const editNotifications = (notification, method) => async (dispatch) => {
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method, notification }
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      if (method === 'Add') {
        await supabase.from('notifications').insert([notification]);
      } else if (method === 'Delete') {
        await supabase.from('notifications').delete().eq('id', notification.id);
      } else {
        await supabase.from('notifications').update(notification).eq('id', notification.id);
      }
    } catch (e) {}
  }
};

export const sendNotification = (notification) => async (dispatch) => {
  dispatch({
    type: SEND_NOTIFICATION,
    payload: notification
  });

  const users = store.getState().usersdata?.users;
  if (users && users.length > 0) {
    let arr = [];
    for (let i = 0; i < users.length; i++) {
      let usr = users[i];
      let pushToken = usr.pushToken || usr.push_token;
      if (!pushToken) continue;

      let obj = {
        to: pushToken,
        title: notification.title,
        msg: notification.body || notification.msg,
      };

      if (notification.usertype === 'All' || usr.usertype === notification.usertype) {
        arr.push(obj);
      }
    }

    if (arr.length > 0) {
      for (let x = 0; x < arr.length; x++) {
        RequestPushMsg(arr[x].to, {
          title: arr[x].title, msg: arr[x].msg
        });
      }
      dispatch({
        type: SEND_NOTIFICATION_SUCCESS,
        payload: arr
      });
      return;
    }
  }

  dispatch({
    type: SEND_NOTIFICATION_FAILED,
    payload: store.getState().languagedata?.defaultLanguage?.no_user_match || 'Nenhum usuário correspondente',
  });
};
